import { render, staticRenderFns } from "./tambahpengajuan.vue?vue&type=template&id=9fa31ec8&"
import script from "./tambahpengajuan.vue?vue&type=script&lang=js&"
export * from "./tambahpengajuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports